import { useEffect, useContext } from 'react';
import { PageHeaderContext } from '~/context';

const usePageHeader = (title: string, onBack?: () => void): void => {
  const { setHeader } = useContext(PageHeaderContext);

  useEffect(() => {
    setHeader(title, onBack);
    return () => setHeader('', undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);
};

export default usePageHeader;
